import AzEnum from '@azinformatica/loki/src/filters/az-enum'
import { situacoes } from '@/core/constants'

export default (situacao) => {
	if (situacao) {
		return AzEnum(situacao, situacoes.ATA).text
	}
	return '--------'
}
